// Core imports
import React, { Fragment } from 'react';

// Component imports
import NdeCreateForm from '../components/NDEs/NdeCreateForm';
import SEO from '../components/SEO/SEO';

const NdeCreateScreen = () => {
  return (
    <Fragment>
      <SEO
        title="Share Your Near-Death Experience"
        description="Anonymously share your near-death experience with the NDE Archive community. Your contribution helps advance the understanding of NDEs."
        path="/ndes/new"
        noIndex
      />
      <NdeCreateForm />
    </Fragment>
  );
};

export default NdeCreateScreen;
